import * as RT from '@radix-ui/react-tooltip';
import type { ReactNode } from 'react';

/** Wrap the app once so every tooltip shares one delay. */
export const TooltipProvider = ({ children }: { children: ReactNode }) => (
  <RT.Provider delayDuration={250}>{children}</RT.Provider>
);

export function Tooltip({ content, children, side = 'top' }: { content: ReactNode; children: ReactNode; side?: 'top' | 'bottom' | 'left' | 'right' }) {
  return (
    <RT.Root>
      <RT.Trigger asChild>{children}</RT.Trigger>
      <RT.Portal>
        <RT.Content className="ui-tooltip" side={side} sideOffset={6}>
          {content}
          <RT.Arrow className="ui-tooltip-arrow" />
        </RT.Content>
      </RT.Portal>
    </RT.Root>
  );
}
